import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectItemTemplateCategorysApi = {
    getProjectItemTemplateCategorys: (): Observable<Dtos.GetProjectItemTemplateCategorysResponse> => {
        //Create the request.
        let request: Dtos.GetProjectItemTemplateCategorys = new Dtos.GetProjectItemTemplateCategorys();

        //Send request.
        const response: Promise<Dtos.GetProjectItemTemplateCategorysResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getProjectItemTemplateCategoryById: (id: number): Observable<Dtos.GetProjectItemTemplateCategoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectItemTemplateCategoryById = new Dtos.GetProjectItemTemplateCategoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetProjectItemTemplateCategoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProjectItemTemplateCategory: (projectItemTemplateCategory: Dtos.ProjectItemTemplateCategory): Observable<Dtos.SetProjectItemTemplateCategoryResponse> => {

        let request: Dtos.SetProjectItemTemplateCategory = new Dtos.SetProjectItemTemplateCategory();

        request.projectItemTemplateCategory = projectItemTemplateCategory;

        // send request
        const response: Promise<Dtos.SetProjectItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createProjectItemTemplateCategory: (): Observable<Dtos.CreateProjectItemTemplateCategoryResponse> => {
        //Create the request.
        let request: Dtos.CreateProjectItemTemplateCategory = new Dtos.CreateProjectItemTemplateCategory();

        //Send request.
        const response: Promise<Dtos.CreateProjectItemTemplateCategoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateProjectItemTemplateCategory: (projectItemTemplateCategory: Dtos.ProjectItemTemplateCategory): Observable<Dtos.ValidateProjectItemTemplateCategoryResponse> => {

        let request: Dtos.ValidateProjectItemTemplateCategory = new Dtos.ValidateProjectItemTemplateCategory();

        request.projectItemTemplateCategory = projectItemTemplateCategory;

        // send request
        const response: Promise<Dtos.ValidateProjectItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    }
}